import { z } from "zod";

export const CampaignFieldsSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  description: z.string(),
  status: z.number().int(),
  isValueActive: z.boolean(),
  redirect: z.boolean(),
});
export const PartialCampaignFieldsSchema = CampaignFieldsSchema.deepPartial();

export const CampaignExtraFieldsSchema = z.object({
  phases: z.any(),
});
export const PartialCampaignExtraFieldsSchema =
  CampaignExtraFieldsSchema.deepPartial();

export const CampaignSchema = z.intersection(
  CampaignFieldsSchema,
  CampaignExtraFieldsSchema
);

export type CampaignFields = z.infer<typeof CampaignFieldsSchema>;
export type PartialCampaignFields = z.infer<typeof PartialCampaignFieldsSchema>;
export type CampaignExtraFields = z.infer<typeof CampaignExtraFieldsSchema>;
export type PartialCampaignExtraFields = z.infer<
  typeof PartialCampaignExtraFieldsSchema
>;
export type Campaign = z.infer<typeof CampaignSchema>;
